'use client'

import { announce } from '@react-aria/live-announcer'
import { FunctionComponent, useEffect } from 'react'
import { toCurrency } from '@/utils/currency.utils'
import TXT from '@/messages'

type Props = {
  grandTotal: number | null
}

const GrandTotalLiveMessage: FunctionComponent<Props> = ({ grandTotal }) => {
  useEffect(() => {
    if (grandTotal) {
      announce(TXT.a11y.cartTotal(toCurrency(grandTotal, 2)), 'polite')
    }
  }, [grandTotal])
  return null
}

export default GrandTotalLiveMessage
